import { motion } from "framer-motion";
import { Typewriter } from "react-simple-typewriter";
import { useNavigate } from "react-router-dom";

import ArrowForwardIcon from "@mui/icons-material/ArrowForward";
import Inventory2OutlinedIcon from "@mui/icons-material/Inventory2Outlined";
import TrendingUpIcon from "@mui/icons-material/TrendingUp";
import AutoAwesomeOutlinedIcon from "@mui/icons-material/AutoAwesomeOutlined";

import Profile1 from "./homepage_images/profile1.jpg";
import Profile2 from "./homepage_images/profile2.jpg";
import Profile3 from "./homepage_images/profile3.jpg";

import Logo from "../logo/universe.png"; // Importing logo image

import HeroSwiper from "./hero_folder/HeroSwiper";

import "./MobileHero.css";
import MobileNavigation from "./MobileNavigation";

const MobileHero = () => {
  const redirect = useNavigate();

  return (
    <div className="mobileHeroWrap">

      {/* =========================================================
          BACKGROUND DECORATION
      ========================================================= */}

      <div className="mobileHeroGlow mobileHeroGlowOne"></div>
      <div className="mobileHeroGlow mobileHeroGlowTwo"></div>

      <div className="mobileHeroGrid"></div>


      {/* =========================================================
          HERO
      ========================================================= */}

      <section className="mobileHero fx-cl">

        {/* =====================================================
            MOBILE HEADER
        ===================================================== */}

        <motion.header
          className="mobileHeroHeader fx-ac fx-jb space3"
          initial={{ opacity: 0, y: -20 }}
          animate={{ opacity: 1, y: 0 }}
          transition={{ duration: 0.6 }}
        >

          <div className="mobileHeroBrand fx-ac space">

            <div className="mobileHeroBrandLogo fx-ac fx-jc">
              <img
                src={Logo}
                alt="Universe Inventory"
              />
            </div>

            <div className="mobileHeroBrandText fx-cl">

              <strong>
                Universe!
              </strong>

              <span>
                Inventory Management
              </span>

            </div>

          </div>


          {/* <div className="mobileHeroHeaderStatus fx-ac fx-jc">

            <span className="mobileHeroStatusPulse">
            </span>

          </div> */}
                <MobileNavigation/>

        </motion.header>


        {/* =====================================================
            HERO INTRO
        ===================================================== */}

        <motion.div
          className="mobileHeroIntro fx-cl fx-ac"
          initial={{ opacity: 0, y: 30 }}
          animate={{ opacity: 1, y: 0 }}
          transition={{
            duration: 0.7,
            delay: 0.15,
            ease: "easeOut",
          }}
        >

          {/* Status Label */}

          <div className="mobileHeroEyebrow fx-ac fx-jc space">

            <span className="mobileHeroEyebrowIcon">
              <AutoAwesomeOutlinedIcon />
            </span>

            <span>
              Built for modern businesses
            </span>

          </div>


          {/* Main Heading */}

          <h1 className="mobileHeroHeading">

            <span className="mobileHeroHeadingStatic">
              Your business.
            </span>

            <span className="mobileHeroHeadingDynamic">

              <Typewriter
                words={[
                  "Under Control.",
                  "Moving Forward.",
                  "Ready to Grow.",
                  "Built to Scale.",
                ]}
                loop={Infinity}
                cursor
                cursorStyle="|"
                typeSpeed={45}
                deleteSpeed={25}
                delaySpeed={3000}
              />

            </span>

          </h1>


          {/* Supporting Copy */}

          <motion.p
            className="mobileHeroDescription"
            initial={{ opacity: 0 }}
            animate={{ opacity: 1 }}
            transition={{ delay: 0.65 }}
          >
            We’re a leading business management platform,
            empowering businesses to grow through reliable
            software, integrity, and a safe, supportive
            environment.
          </motion.p>

        </motion.div>


        {/* =====================================================
            CTA AREA
        ===================================================== */}

        <motion.div
          className="mobileHeroActions fx-cl fx-ac"
          initial={{ opacity: 0, y: 25 }}
          animate={{ opacity: 1, y: 0 }}
          transition={{
            duration: 0.6,
            delay: 0.75,
          }}
        >

          <button
            className="mobileHeroPrimaryButton fx-ac"
            onClick={() => redirect("/create_new_account")}
          >

            <span>
              Get started in few steps
            </span>

            <span className="mobileHeroPrimaryIcon fx-ac fx-jc">
              <ArrowForwardIcon />
            </span>

          </button>


          <div className="mobileHeroTrust fx-ac">

            <div className="mobileHeroAvatars fx-ac">

              <div className="mobileHeroAvatar">
                <img src={Profile2} alt="" />
              </div>

              <div className="mobileHeroAvatar">
                <img src={Profile3} alt="" />
              </div>

              <div className="mobileHeroAvatar">
                <img src={Profile1} alt="" />
              </div>

              <div className="mobileHeroAvatarMore fx-ac fx-jc">
                +
              </div>

            </div>

            <div className="mobileHeroTrustText fx-cl">

              <strong>
                Growing together
              </strong>

              <span>
                Connecting users around the world
              </span>

            </div>

          </div>

        </motion.div>


        {/* =====================================================
            PRODUCT PREVIEW AREA
        ===================================================== */}

        <motion.div
          className="mobileHeroProductArea"
          initial={{
            opacity: 0,
            y: 50,
            scale: 0.94,
          }}
          animate={{
            opacity: 1,
            y: 0,
            scale: 1,
          }}
          transition={{
            duration: 0.9,
            delay: 0.95,
            ease: "easeOut",
          }}
        >

          {/* Floating Inventory Card */}

          <motion.div
            className="mobileHeroFloatingCard mobileHeroInventoryCard"
            initial={{
              opacity: 0,
              x: -30,
              y: 20,
            }}
            animate={{
              opacity: 1,
              x: 0,
              y: 0,
            }}
            transition={{
              delay: 1.35,
              duration: 0.6,
            }}
          >

            <div className="mobileHeroFloatingIcon fx-ac fx-jc">
              <Inventory2OutlinedIcon />
            </div>

            <div className="mobileHeroFloatingInfo fx-cl">

              <span>
                Inventory
              </span>

              <strong>
                Organized
              </strong>

            </div>

          </motion.div>


          {/* Floating Growth Card */}

          <motion.div
            className="mobileHeroFloatingCard mobileHeroGrowthCard"
            initial={{
              opacity: 0,
              x: 30,
              y: 20,
            }}
            animate={{
              opacity: 1,
              x: 0,
              y: 0,
            }}
            transition={{
              delay: 1.5,
              duration: 0.6,
            }}
          >

            <div className="mobileHeroFloatingIcon mobileHeroGrowthIcon fx-ac fx-jc">
              <TrendingUpIcon />
            </div>

            <div className="mobileHeroFloatingInfo fx-cl">

              <span>
                Business
              </span>

              <strong>
                Growing
              </strong>

            </div>

          </motion.div>


          {/* Dashboard */}

          <div className="mobileHeroDashboard">

            {/* Dashboard Browser Bar */}

            <div className="mobileHeroDashboardTop fx-ac fx-jb">

              <div className="mobileHeroBrowserDots fx-ac space">

                <span></span>
                <span></span>
                <span></span>

              </div>

              <div className="mobileHeroDashboardLabel fx-ac space">

                <span className="mobileHeroLiveDot"></span>

                <span>
                  Universe
                </span>

              </div>

            </div>


            {/* Dashboard Content */}

            <div className="mobileHeroDashboardContent">

              <HeroSwiper />

            </div>

          </div>

        </motion.div>


        {/* =====================================================
            BOTTOM FEATURE STRIP
        ===================================================== */}

        <motion.div
          className="mobileHeroFeatureStrip fx-ac fx-jc space"
          initial={{ opacity: 0, y: 15 }}
          animate={{ opacity: 1, y: 0 }}
          transition={{ delay: 1.5 }}
        >

          <div className="mobileHeroFeature fx-ac space">

            <span className="mobileHeroFeatureCheck">
              ✓
            </span>

            <span>
              Inventory
            </span>

          </div>

          <span className="mobileHeroFeatureDivider"></span>

          <div className="mobileHeroFeature fx-ac space">

            <span className="mobileHeroFeatureCheck">
              ✓
            </span>

            <span>
              Sales
            </span>

          </div>

          <span className="mobileHeroFeatureDivider"></span>

          <div className="mobileHeroFeature fx-ac space">

            <span className="mobileHeroFeatureCheck">
              ✓
            </span>

            <span>
              Business
            </span>

          </div>

        </motion.div>


        {/* =====================================================
            BOTTOM SCROLL INDICATOR
        ===================================================== */}

        <motion.div
          className="mobileHeroExplore fx-cl fx-ac"
          initial={{ opacity: 0 }}
          animate={{ opacity: 1 }}
          transition={{ delay: 1.8 }}
        >

          <span>
            Explore Universe
          </span>

          <div className="mobileHeroExploreArrow">
            ↓
          </div>

        </motion.div>

      </section>

    </div>
  );
};

export default MobileHero; 